import React, { useEffect } from "react";
import { Row, Col } from "antd";
import { useIntl } from "react-intl";
import { useCreateSubscription } from "queries/memberships";
import messages from "./translations";
import Loader from "shared/LoaderComponent";
import CreditCardsDisplay from "views/app-views/SingleContactPage/CreditCards/CreditCardsDisplay";

export const ExistingCard = ({
  card,
  handleNextStep,
  selectedCard,
  setSelectedCard,
}) => {
  const { formatMessage } = useIntl();
  const subscribe = useCreateSubscription(
    formatMessage(messages.successfullSubscription)
  );

  useEffect(() => {
    if (subscribe.isSuccess) {
      handleNextStep();
    }
  }, [subscribe.isSuccess]);

  return (
    <Row>
      <Loader isLoading={subscribe.isLoading} />
      <Col span={24}>
        <CreditCardsDisplay
          card={card}
          selected={selectedCard?.id === card?.id}
          onCardClick={() => setSelectedCard(card)}
        />
      </Col>
    </Row>
  );
};

const ExistingCards = ({
  cards,
  selectedCard,
  handleNextStep,
  setSelectedCard,
}) => {
  if (!cards?.length) {
    return null;
  }

  return (
    <div className="my-4 w-100">
      {cards.map((card) => (
        <ExistingCard
          key={card.id}
          card={card}
          selectedCard={selectedCard}
          setSelectedCard={setSelectedCard}
          handleNextStep={handleNextStep}
        />
      ))}
    </div>
  );
};

export default ExistingCards;
